(function(){
  var ARROW = { prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>', next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>' };
  function thumbButtons(thumbs){ return Array.prototype.slice.call(thumbs.querySelectorAll('.thumbnail-list__item button.thumbnail')); }
  function autoplayFirstVideo(viewer){
    var dm = viewer.querySelector('.product__media-item.is-active deferred-media');
    if (!dm || dm.getAttribute('loaded')) return;
    var tpl = dm.querySelector('template');
    var v = tpl && tpl.content && tpl.content.querySelector('video');
    if (!v || typeof dm.loadContent !== 'function') return;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('autoplay', ''); v.setAttribute('loop', '');
    dm.loadContent(false);
    var vv = dm.querySelector('video');
    if (vv) { vv.muted = true; var p = vv.play(); if (p && p.catch) p.catch(function(){}); }
  }
  function init(gallery){
    if (gallery.dataset.xmasInit) return;
    gallery.dataset.xmasInit = '1';
    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails-"]');
    if (!viewer) return;
    autoplayFirstVideo(viewer);
    if (!thumbs || thumbButtons(thumbs).length < 2) return;
    function step(d){
      var list = thumbButtons(thumbs);
      var cur = -1;
      for (var i = 0; i < list.length; i++) { if (list[i].getAttribute('aria-current') === 'true') { cur = i; break; } }
      if (cur < 0) cur = 0;
      var n = (cur + d + list.length) % list.length;
      list[n].click();
      var li = list[n].closest('li');
      var track = li && li.parentElement;
      if (track && track.scrollTo) track.scrollTo({ left: li.offsetLeft - (track.clientWidth - li.clientWidth) / 2, behavior: 'smooth' });
    }
    var nav = document.createElement('div');
    nav.className = 'xmas-gal-nav';
    ['prev', 'next'].forEach(function(dir){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'xmas-gal-btn xmas-gal-btn--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = ARROW[dir];
      b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); step(dir === 'prev' ? -1 : 1); });
      nav.appendChild(b);
    });
    viewer.appendChild(nav);
  }
  function run(){ document.querySelectorAll('media-gallery').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
